export const structure = {
  map: {},
  fields: {
    pvk: null
  },
  activeType: ''
}

export const nonClearableFields = ['map']
